<template>
  <div class="v-atlas-app">
    <div class="v-atlas-app__menubar">
      <SystemButtons />
    </div>
    <div class="v-atlas-app__router-view">
      <RouterView :key="$route.fullPath" />
    </div>


    <!--#region Out of layout flow-->
    <ToastNotification />
    <Tooltip :enable-on-touch="false" />
    <ContextHelp />
    <ContextMenu />
    <!--#endregion Out of layout flow-->

  </div>
</template>

<script setup lang="ts">

import { ContextMenu, ContextHelp, Tooltip } from 'gertrud'
import ToastNotification from '@/components/ToastNotification.vue'

import SystemButtons from './SystemButtons.vue';



</script>
